// Copyright (c) Move Closer 2022.

import { Component, Prop } from 'vue-property-decorator'
import { Inject } from '../../../support'

import { IProductsRepository, ProductsRepositoryType } from '../../products/contracts/repositories'
import { IRelatedService, RelatedServiceType } from '../../../contexts'

import { AbstractModal } from '../organisms/AbstractModal'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
@Component<AddedToCartModalMixin>({
  name: 'AddedToCartModalMixin',
  mounted (): void {
    // this.loadSuggestedProducts()
  }
})
export class AddedToCartModalMixin extends AbstractModal {
  @Inject(ProductsRepositoryType)
  protected readonly productsRepository!: IProductsRepository

  @Inject(RelatedServiceType)
  protected readonly relatedService!: IRelatedService

  @Prop({ type: String, required: false, default: null })
  public readonly buttonIcon!: string | null

  public isLoading: boolean = true

  /**
   * TODO:When loading suggested products use logic in:
   * @see AddedToCartModal
   */

  /**
   * List of suggestedProducts
   */
  // public suggestedProducts: CartItemProps[] = []

  /**
   * Determines whether there are suggested products.
   */
  // public get hasSuggestedProducts (): boolean {
  //   return Array.isArray(this.suggestedProducts) && this.suggestedProducts.length > 0
  // }

  /**
   * Loads (fetches) the list of suggested products.
   */
  // public async loadSuggestedProducts (): Promise<void> {
  //   try {
  //     const suggestedProducts = await this.productsRepository.loadSuggestedProductsList()
  //
  //     this.relatedService.storeRelated(suggestedProducts.relatedRecords)
  //
  //     let resolvedProducts =
  //       await this.relatedService.resolve<ProductData[]>(suggestedProducts.suggestedProducts)
  //
  //     if (resolvedProducts.length > 2) {
  //       resolvedProducts = resolvedProducts.slice(0, 2)
  //     }
  //
  //     this.suggestedProducts = resolvedProducts.map((product: ProductData) => {
  //       return translateToCartItem(product, ['noQuantity', 'isDisabled'])
  //     })
  //   } catch (e) {
  //     logger(e, 'warn')
  //   } finally {
  //     this.isLoading = false
  //   }
  // }

  /**
   * Redirect user to cart page.
   */
  public async goToCart (): Promise<void> {
    this.close()

    await this.$router.push({ name: 'checkout.cart' })
  }
}
